/**
 * Composable for tracking article views
 * Manages view tracking with delay and duplicate prevention
 */

const trackedArticles = new Set();

/**
 * Tracks an article view
 * @param {string} portalSlug - Portal slug
 * @param {string} articleSlug - Article slug
 * @param {number} delay - Delay in ms before tracking (default: 2000ms)
 */
export const trackArticleView = (portalSlug, articleSlug, delay = 2000) => {
  const trackingKey = `${portalSlug}/${articleSlug}`;

  if (trackedArticles.has(trackingKey)) {
    return;
  }

  trackedArticles.add(trackingKey);

  setTimeout(() => {
    const img = new Image();
    img.src = `${window.location.origin}/hc/${portalSlug}/articles/${articleSlug}.png`;
  }, delay);
};

/**
 * Clears tracked articles history (useful for testing)
 */
export const clearTrackedArticles = () => {
  trackedArticles.clear();
};
